import { animate, state, style, transition, trigger } from '@angular/animations';
import { Component, Input } from '@angular/core';
import { FileBranch, FileDetails } from 'src/app/classes/fileInfo';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { FileService } from 'src/app/services/file.service';


@Component({
	selector: 'app-branch-display',
	templateUrl: './branch-display.component.html',
	styleUrl: "./branch-display.component.scss",
	// animations: [ flyInOut ]
	animations: [
		trigger( 'detailExpand', [
			state( 'void', style( { height: '0px', minHeight: '0', opacity: 0 } ) ),
			state( '*', style( { height: '*', opacity: 1 } ) ),
			transition( 'void <=> *', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)') ),
		]),
	],
})
export class BranchDisplayComponent {


	@Input() branch = new FileBranch();

	bAdmin = this.authenticationService.isAdmin();


	constructor(
		private fileService: FileService,
		private authenticationService: AuthenticationService
	) {}


	download( file: FileDetails ) {
		this.fileService.downloadFile( file.hash, file.fileName );
	}

	clickCreateFolder() {
		this.fileService.requestNewFolder$.next( this.getPath() );
	}

	clickUpload() {
		this.fileService.requestFileUpload$.next( this.getPath() );
	}

	private getPath(): string {

		let path = this.branch.folder.fileRelativePfad;
		if( !path.length ) return "";
		if( path[0] == '.' ) path = path.substring( 1 );
		if( !path.length ) return "";
		if( path[0] == '\\' ) path = path.substring( 1 );
		if( !path.length ) return "";

		return path;

	}

}
